import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Close on ESC key
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-245">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100] flex items-center justify-center p-4" data-id="element-246">
            {/* Modal Container */}
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} onClick={e => e.stopPropagation()} className="bg-[#F5F1E8] w-full max-w-2xl max-h-[85vh] rounded-xl shadow-2xl overflow-hidden flex flex-col border border-[#C9A961]/20 relative" data-id="element-247">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-[#C9A961]/10 bg-white/50" data-id="element-248">
                <h2 className="text-2xl font-bold text-[#1a3a52]" data-id="element-249">{title}</h2>
                <button onClick={onClose} className="p-2 rounded-full hover:bg-[#1a3a52]/5 text-gray-500 hover:text-[#C9A961] transition-colors duration-200" aria-label="Cerrar" data-id="element-250">
                  <X size={24} data-id="element-251" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 md:p-8 overflow-y-auto custom-scrollbar text-[#1a3a52]/80 leading-relaxed" data-id="element-252">
                {children}
              </div>
            </motion.div>
          </motion.div>
        </>}
    </AnimatePresence>;
}